module.exports = __webpack_public_path__ + "img/bglogin.c760be4a.png";